import type { ViewInformationModalProps } from '../../../config/modalConfig';
import ShoppingBasketGovernmentFeeText from './ShoppingBasketGovernmentFeeText';
import type { FeeDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/quote/submission/dto/';
import { useHippoText } from '../../../hooks/useHippoText';

const ShoppingBasketGovernmentFee = ({
    governmentFees,
    isPaymentYearly
}: {
    governmentFees: FeeDTO[];
    isPaymentYearly: boolean;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const viewInformationModalContentMap: Record<string, ViewInformationModalProps> = {
        'Naturskadeafgift til staten': {
            title: getHippoText('top-online-sales.governmentFeeModal.FloodAndHurricaneFeeTitle'),
            description: getHippoText(
                'top-online-sales.governmentFeeModal.FloodAndHurricaneFeeContent'
            )
        },
        'Bidrag til Garantifonden': {
            title: getHippoText('top-online-sales.governmentFeeModal.GuaranteeFeeTitle'),
            description: getHippoText('top-online-sales.governmentFeeModal.GuaranteeFeeContent')
        },
        'Bidrag til Garantifonden for Arbejdsskadeforsikring': {
            title: getHippoText('top-online-sales.governmentFeeModal.GuaranteeFeeWorkersCompTitle'),
            description: getHippoText(
                'top-online-sales.governmentFeeModal.GuaranteeFeeWorkersCompContent'
            )
        }
    };
    return (
        <div>
            <p className={'paragraph--small u-color-secondary-4-medium'}>
                Herudover betaler du hvert år lovbestemte afgifter og bidrag, vi som
                forsikringsselskab skal opkræve på vegne af staten.
            </p>
            <div className="u-spacing-inset-m--stretch-max">
                {governmentFees.map((fee) => {
                    return (
                        <ShoppingBasketGovernmentFeeText
                            key={fee.feeName}
                            fee={fee}
                            modalProps={viewInformationModalContentMap[fee.feeName ?? '']}
                        />
                    );
                })}
            </div>
            {!isPaymentYearly ? (
                <p className={'paragraph--small u-color-secondary-4-medium u-spacing-stack-none'}>
                    De beløb betaler du kun én gang om året, nemlig første gang du betaler i et
                    kalenderår.
                </p>
            ) : (
                <hr className="u-border-primary-1-base" />
            )}
        </div>
    );
};

export default ShoppingBasketGovernmentFee;
